import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'cars/car';
const model = 'cars/car';
const wizardName = 'Driver dissociation';
const wizardObject = 'Driver';
const wizardAction = 'personDissociation';

const PersonDissociation = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const [drawable, setDrawable] = useState(true);
    const { doAction, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const [dissociated, setDissociated] = useState([])

    const handleCheckChange = (event) => {
        const checked = event.target.checked;
        const value = event.target.value;

        setDissociated((prev) => {
            if (checked) {
                return prev.includes(value) ? prev : [...prev, value];
            } else {
                return prev.filter((v) => v !== value);
            }
        });
    };

    const detailConfig = {
        "tabs": [
            {
                "name": "dissociation",
                "fieldsets": [
                    {
                        "name": "dissociation",
                        "fields": {
                            "person_assigned": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "dissociated": {
                                "type": "relationship",
                                "view": "pool",
                                "readonly": true,
                                "checkable": true,
                                "checked": true,
                                "onCheckChange": handleCheckChange,
                                "relation": {
                                    "drawerRoutes": "pools",
                                    "inverseRelation": "car",
                                    "inverseRelationType": "relationship",
                                    "relationAssociator": "hidden",
                                    "relationDissociator": "hidden"
                                }
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(true)

    useEffect(() => {
        if (success) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success]);

    const handleSave = async (data) => {
        data.dissociated = dissociated;
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    disableDetailConfigOverride={true}
                    values={{
                        "id": item?.data?._id,
                        "dissociated": item?.data?.pools
                    }}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    save={handleSave}
                    onEditing={setEditing}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    title={t(wizardName)}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t(wizardName)}
                            subtitle={(item.data?.pool?.isPool === 'true') ? t('Remove a {{wizardObject}} from Pool {{pool}}', { wizardObject: wizardObject, pool: (item.data?.pool?.name) }) : t('Remove a {{wizardObject}} from {{carIdentifier}}', { wizardObject: wizardObject, carIdentifier: (item.data.plate ? item.data.plate : item.data.setup?.make + " " + item.data.setup?.model) })}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default PersonDissociation;